import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
import { backofficeUrlBase } from '@/config/envConfig';
function jsonToFromData(data) {
    const formData = new FormData();
    const keys = Object.keys(data);
    keys.forEach(key => {
        formData.append(key, data[key]);
    });
    return formData;
}
let LabApi = class LabApi {
    constructor(http) {
        this.http = http;
        this.baseUrl = backofficeUrlBase + '/backoffice/proxy/lab-service';
    }
    getAppsPagination(params) {
        return this.http.get({
            url: `${this.baseUrl}/apps/pagination`,
            params,
        });
    }
    putAppStaging(params) {
        return this.http.put({
            url: `${this.baseUrl}/apps/app/staging`,
            data: params,
        });
    }
    getDeveloperPagination(s_email) {
        return this.http.get({
            url: `${this.baseUrl}/apps/developer/pagination`,
            params: {
                s_email,
            },
        });
    }
    putAppsApp(params) {
        return this.http.put({
            url: `${this.baseUrl}/apps/app`,
            data: params,
        });
    }
    /**
     * 应用启用
     */
    putAppsAppUsed(params) {
        return this.http.put({
            url: `${this.baseUrl}/apps/app/used`,
            data: params,
        });
    }
    /**
     * 应用状态统计
     */
    getStagingStatisticsApi() {
        return this.http.get({
            url: `${this.baseUrl}/apps/app/staging-statistics`,
        });
    }
    /**
     * 应用打分排名
     */
    getScoreRankingApi(params) {
        return this.http.get({
            url: `${this.baseUrl}/apps/app/score-ranking`,
            params,
        });
    }
    /**
     * APP启用统计
     */
    getUsedStatisticsApi(params) {
        return this.http.get({
            url: `${this.baseUrl}/apps/app/used-statistics`,
            params,
        });
    }
    // 获取app 对应的用户列表
    getUsedStatisticsUserApi(app_id, params) {
        return this.http.get({
            url: `${this.baseUrl}/apps/app/${app_id}/used-pagination`,
            params,
        });
    }
    // 获取app 对应的公司列表
    getUsedStatisticsCompanyApi(company_id, params) {
        return this.http.get({
            url: `${this.baseUrl}/apps/app/${company_id}/used-statistics`,
            params,
        });
    }
    // 删除 app
    deleteApp(data) {
        return this.http.put({
            url: `${this.baseUrl}/apps/app/staging`,
            data,
        });
    }
    // #region Feedback
    searchFeedback(params) {
        return this.http.get({
            url: `${this.baseUrl}/feedback/backstage-pagination`,
            params,
        });
    }
    feedbackPass(params) {
        return this.http.put({
            url: `${this.baseUrl}/feedback/staging`,
            data: params,
        });
    }
    feedbackRefuse(params) {
        return this.http.put({
            url: `${this.baseUrl}/feedback/staging`,
            data: params,
        });
    }
    deleteFeedback(id) {
        return this.http.delete({
            url: `${this.baseUrl}/feedback/delete/${id}`,
        });
    }
    // #endregion
    // app 开启统计趋势
    getAppOpenTrend(params) {
        return this.http.get({
            url: `${this.baseUrl}/apps/app/detail/count`,
            params: {
                range: params.granularity,
                start: params.start_time,
                end: params.end_time,
                s_filter_internal: params.s_filter_internal,
            },
        });
    }
    // app 开启详细数据
    getAppOpenDetails(params) {
        return this.http.get({
            url: `${this.baseUrl}/apps/app/detail/info`,
            params: {
                range: params.granularity,
                start: params.start_time,
                end: params.end_time,
                app_id: params.app_id,
                s_filter_internal: params.s_filter_internal,
            },
        });
    }
    createAbTestItem(data) {
        return this.http.put({
            url: `${this.baseUrl}/ab-test/feature/save`,
            data,
        });
    }
    updateAbTestItem(data) {
        return this.http.post({
            url: `${this.baseUrl}/ab-test/feature/update`,
            data,
        });
    }
    getAbTestList(params) {
        return this.http.get({
            url: `${this.baseUrl}/ab-test/feature/list`,
            params,
        }).then(d => {
            return d.data;
        });
    }
    getAbTestItemDetail(id) {
        return this.http.get({
            url: `${this.baseUrl}/ab-test/feature/${id}`,
        }).then(d => {
            return d.data;
        });
    }
    updateAbTestConfig(data) {
        return this.http.post({
            headers: {
                'X-API-Version': '2.0',
            },
            url: `${this.baseUrl}/ab-test/feature-limit/save`,
            data,
        });
    }
    getAbTestConfigDetail(id) {
        return this.http.get({
            url: `${this.baseUrl}/ab-test/feature-limit/${id}`,
        }).then(d => {
            return d.data;
        });
    }
    deleteAbTestItem(id) {
        return this.http.delete({
            url: `${this.baseUrl}/ab-test/feature/${id}`,
        });
    }
    uploadExcel(params, key) {
        const url = `${this.baseUrl}/ab-test/analysis-id`;
        const formData = jsonToFromData(params);
        return this.http.postForm({
            url,
            data: formData,
            params: {
                feature_key: key,
            },
        });
    }
    /**
     *
     * @returns 获取已配置的用户/公司列表
     */
    getSpecialConfig(data) {
        return this.http.get({
            url: `${this.baseUrl}/ab-test/feature-limit/list`,
            params: {
                feature_key: data.feature_key,
                limit_type: data.limit_type,
                page: data.page,
                limit: data.limit,
            },
        }).then(d => {
            return d.data;
        });
    }
    /**
     *
     * @returns 保存配置的用户id或者公司id
     */
    addSpecialItemConfig(data) {
        return this.http.post({
            url: `${this.baseUrl}/ab-test/feature-limit`,
            data,
        });
    }
    /**
     *
     * @returns 删除用户或者公司
     */
    removeSpecialConfig(data) {
        return this.http.delete({
            url: `${this.baseUrl}/ab-test/feature-limit`,
            data,
        });
    }
};
LabApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.LabHttp)),
    __metadata("design:paramtypes", [Object])
], LabApi);
export { LabApi };
